import { render } from "./formpassword.vue?vue&type=template&id=23cf657a"
import script from "./formpassword.vue?vue&type=script&lang=js"
export * from "./formpassword.vue?vue&type=script&lang=js"

import "./formpassword.vue?vue&type=style&index=0&id=23cf657a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__